export  const getUrl = () => {
  const base = (() => {
    if (typeof window !== 'undefined') {
      return '';
    }

    if (process.env.VERCEL_URL) {
      return `https://${process.env.VERCEL_URL}`;
    }

    return `http://localhost:${process.env.PORT}`;
  })();

  return `${base}/api/trpc`;
};
